(function () {
  const result = document.querySelector("#delivery-result");
  const mapNotice = document.querySelector("#map-notice");

  function setResultForRegion(region, matchedCode, options = {}) {
    const statusLabel = window.DeliveryData.statusLabels[region.status] || "Delivery area";
    const message = options.fullPostalCode
      ? "Yes, we deliver to that area!"
      : "Yes, we deliver to that region! Please enter your full Postal Code to confirm exact delivery status.";
    result.className = `result-card is-${region.status}`;
    result.innerHTML = `
      <p class="result-kicker">${statusLabel}${matchedCode ? ` · ${matchedCode}` : ""}</p>
      <p>${message}</p>
    `;
  }

  function setCoverageSummary(regions) {
    const restrictedRegions = regions.filter((region) => region.allowedPostalCodes);
    result.className = "result-card is-active";
    result.innerHTML = `
      <p class="result-kicker">Active delivery area</p>
      <h2>${regions.length} delivery FSAs loaded</h2>
      <p>The active delivery area is displayed on the map. Search a postal code or FSA to check a specific address area.</p>
    `;
  }

  function setNotFound(query) {
    result.className = "result-card is-error";
    result.innerHTML = `
      <p class="result-kicker">We don't deliver to ${query} (yet)</p>
      <p>We're working on expanding our delivery areas, so check back soon!</p>
    `;
  }

  window.DeliveryUI = {
    showMapNotice(message) {
      mapNotice.textContent = message;
      mapNotice.hidden = false;
    },
    setCoverageSummary,
    setResultForRegion,
    setNotFound
  };
})();
